import { render, staticRenderFns } from "./TabApproverFinalGlobal.vue?vue&type=template&id=10dfa331&scoped=true&"
import script from "./TabApproverFinalGlobal.vue?vue&type=script&lang=js&"
export * from "./TabApproverFinalGlobal.vue?vue&type=script&lang=js&"
import style0 from "./TabApproverFinalGlobal.vue?vue&type=style&index=0&id=10dfa331&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dfa331",
  null
  
)

export default component.exports